module.exports = __webpack_public_path__ + "static/media/back.ddfef4a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/back.svg
// module id = 48
// module chunks = 0